import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { generateConfig } from '../../utils/api';
import { handleApiError } from '../../utils/apiErrorHandler';

export const fetchJourneys = createAsyncThunk(
  'journeys/fetchJourneys',
  async (clinicId, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });
      const response = await axios.get(`${baseURL}/api/journeys?clinicId=${clinicId}`, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const fetchJourneyById = createAsyncThunk(
  'journeys/fetchJourneyById',
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });
      const response = await axios.get(`${baseURL}/api/journeys/${id}`, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const createJourney = createAsyncThunk(
  'journeys/createJourney',
  async (journeyData, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });
      const response = await axios.post(`${baseURL}/api/journeys`, journeyData, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const updateJourney = createAsyncThunk(
  'journeys/updateJourney',
  async ({ id, journeyData }, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });
      const response = await axios.put(`${baseURL}/api/journeys/${id}`, journeyData, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const deleteJourney = createAsyncThunk(
  'journeys/deleteJourney',
  async (id, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });
      await axios.delete(`${baseURL}/api/journeys/${id}`, config);
      return id;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);

export const copyJourneyToClinic = createAsyncThunk(
  'journeys/copyJourneyToClinic',
  async ({ journeyId, targetClinicId }, { rejectWithValue, getState, dispatch }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      const { baseURL, config } = generateConfig({ token });
      const response = await axios.post(`${baseURL}/api/journeys/copy`, { journeyId, targetClinicId }, config);
      return response.data;
    } catch (error) {
      return handleApiError(error, rejectWithValue, dispatch);
    }
  }
);